import crc32 from 'fbjs/lib/crc32';
import emitter from './emitter';

// touches no emitter state, so a caller outside React can allocate exactly as the hook does
export const selectWeightedVariant = (variants, weights, userIdentifier) => {
	// Sum the weights
	const weightSum = weights.reduce((a, b) => {
		return a + b;
	}, 0);
	// console.log('weightSum', weightSum);

	// console.log('userIdentifier', userIdentifier);
	// A random number between 0 and weightSum
	let weightedIndex =
		typeof userIdentifier === 'string'
			? Math.abs(crc32(userIdentifier) % weightSum)
			: Math.floor(Math.random() * weightSum);
	// console.log('weightedIndex', weightedIndex);
	// Iterate through the sorted weights, and deduct each from the weightedIndex.
	// If weightedIndex drops < 0, select the variant. If weightedIndex does not
	// drop < 0, default to the last variant in the array that is initially assigned.
	let selectedVariant = variants[variants.length - 1];
	// console.log('selectedVariant', selectedVariant);
	for (let index = 0; index < weights.length; index++) {
		weightedIndex -= weights[index];
		if (weightedIndex < 0) {
			selectedVariant = variants[index];
			break;
		}
	}
	// console.log('selectedVariant', selectedVariant);

	return selectedVariant;
};

const calculateExperimentVariant = (experimentName, userIdentifier) => {
	/*
  
	  Choosing a weighted variant:
		For C, A, B with weights 2, 4, 8
  
		variants = A, B, C
		weights = 4, 8, 2
		weightSum = 14
		weightedIndex = 9
  
		AAAABBBBBBBBCC
		========^
		Select B
  
	  */

	// Sorted array of the variant names, example: ["A", "B", "C"]
	const variants = emitter.getSortedExperimentVariants(experimentName);
	// console.log('variants', variants);
	// Array of the variant weights, also sorted by variant name. For example, if
	// variant C had weight 2, variant A had weight 4, and variant B had weight 8
	// return [4, 8, 2] to correspond with ["A", "B", "C"]
	const weights = emitter.getSortedExperimentVariantWeights(experimentName);
	// console.log('weights', weights);
	const selectedVariant = selectWeightedVariant(variants, weights, userIdentifier);

	emitter.setActiveExperimentVariant(experimentName, selectedVariant);

	return selectedVariant;
};

// storage access throws outright in private mode and when site data is blocked, which would take
// the whole allocator down rather than falling through to the default variant
const readStoredVariant = (experimentName) => {
	try {
		return localStorage.getItem('READYRX-' + experimentName);
	} catch (error) {
		return null;
	}
};

const calculateActiveExperimentVariant = (experimentName, userIdentifier, defaultVariantName) => {
	if (typeof userIdentifier === 'string') {
		return calculateExperimentVariant(experimentName, userIdentifier);
	}

	const activeValue = emitter.getActiveExperimentVariant(experimentName);
	if (typeof activeValue === 'string') {
		return activeValue;
	}

	const storedValue = readStoredVariant(experimentName);
	if (typeof storedValue === 'string') {
		emitter.setActiveExperimentVariant(experimentName, storedValue, true);

		return storedValue;
	}

	if (typeof defaultVariantName === 'string') {
		emitter.setActiveExperimentVariant(experimentName, defaultVariantName);

		return defaultVariantName;
	}

	return calculateExperimentVariant(experimentName);
};

export default calculateActiveExperimentVariant;